import { dataMember, required, typedArray } from 'santee-dcts';
import * as moment from 'moment';
import { deserializers } from '../../core';
import { OnScreenResults } from '../on-screen-results';
import { isEmpty } from 'lodash';

export class MicrobiologyData extends OnScreenResults {

    @dataMember()
    public ctSubjectId: number;

    @dataMember()
    public accessionId: number;

    @dataMember()
    @required({ nullable: true })
    public accessionNumber: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public collectionDateTime: moment.Moment;

    @dataMember()
    @required({ nullable: true })
    public testGroupName: string;

    @dataMember()
    @required({ nullable: true })
    public testSequence: number;

    @dataMember()
    public growth: string;

    @dataMember()
    public specimen: string;

    @dataMember()
    public organism: string;

    @dataMember()
    public organismComment: string;

    @dataMember()
    public agent: string;

    @dataMember()
    public micResult: string;

    @dataMember()
    public micPanelInterpretation: string;

    @dataMember()
    public kirbyBauerPanelZone: string;

    @dataMember()
    public kirbyBauerInterpretation: string;

    @dataMember()
    @required({ nullable: true })
    public invalidKbPanelMessage: string;

    @dataMember()
    @required({ nullable: true })
    public invalidMicPanelMessage: string;

    @dataMember()
    public test: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public testCollectionDateTime: moment.Moment;

    @dataMember()
    public testAccessionId: number;

    @dataMember()
    @required({ nullable: true })
    public result: string;

    @dataMember()
    @required({ nullable: true })
    public sequence: number;

    @dataMember()
    public referenceRange: string;

    @dataMember()
    public observations: string;

    @dataMember()
    public finalReport: string;

    @dataMember()
    public type: string;

    @dataMember()
    public kitTypeDescription: string;

    @dataMember()
    public testDescription: string;

    @dataMember()
    public isSubTestCancelled: boolean;

    @dataMember()
    public subTestCancellationReason: string;

    @dataMember()
    public panel: string;

    @dataMember()
    public hasSubjectDataRevision: boolean;

    @dataMember()
    public hasVisitDataRevision: boolean;

    @dataMember()
    public hasSpecimenResultDataRevision: boolean;

    @dataMember()
    public hasOrganismResultDataRevision: boolean;

    @dataMember()
    public hasGrowthResultDataRevision: boolean;

    @dataMember()
    public hasTestResultDataRevision: boolean;

    @dataMember()
    public hasMicPanelResultDataRevision: boolean;

    @dataMember()
    public hasMicPanelInterpretationDataRevision: boolean;

    @dataMember()
    public hasKbPanelResultDataRevision: boolean;

    @dataMember()
    public hasKbPanelInterpretationDataRevision: boolean;

    @dataMember()
    public units: string;

    @dataMember()
    @required({ nullable: true })
    public isSubGroupCancelled: boolean;

    @dataMember()
    @required({ nullable: true })
    public subGroupCancellationReason: string;

    @dataMember()
    public microTestId: number;
    

    public get uniqMicroDataKey(): string {
        return `${this.agent} : ${this.panel}`;
    }

    public get visitColumnKey(): string {
        return `${this.collectionDateTime} : ${this.accessionId}`;
    }

    public get testCollectionKey(): string {
        return `${this.testCollectionDateTime} : ${this.testAccessionId}`;
    }

    public get fullOrganismTitle() {
        const data: string[] = [];

        if (!isEmpty(this.organism)) {
            data.push(this.organism);
        }

        if (!isEmpty(this.organismComment)) {
            data.push(`(${this.organismComment})`);
        }

        return data.join(' ');
    }

    public setPanel(panel: string) {
        this.panel = panel;
    }

    public get isSubCancelled(): boolean {
        return this.isSubTestCancelled || this.isSubGroupCancelled;
    }

    public get subCancellationReason(): string {

        if (this.isSubGroupCancelled) {
            return `Test group cancelled: ${this.subGroupCancellationReason}`;
        } else if (this.isSubTestCancelled) {
            return `Test cancelled: ${this.subTestCancellationReason}`;
        }

        return '';
    }
}

export class MicrobiologyDataReadModel {
    @dataMember()
    @required()
    @typedArray(MicrobiologyData)
    public results: MicrobiologyData[];
}

